import { BoxGeometry, Euler, Material, Mesh, Object3D } from "three";
import { baseMaterial } from "./Materials";

export interface BoxCreateOptions {
  width: number;
  height: number;
  depth: number;
  offsetX?: number;
  offsetY?: number;
  offsetZ?: number;
  rotation?: Euler;
}

export function createBox(
  options: BoxCreateOptions,
  material?: Material
): Object3D {
  const {
    width,
    height,
    depth,
    offsetX = 0,
    offsetY = 0,
    offsetZ = 0,
    rotation,
  } = options;

  const mesh = new Mesh(
    new BoxGeometry(width, height, depth),
    material ? material : baseMaterial
  );

  mesh.position.set(offsetX + width / 2, offsetY + height / 2, offsetZ);

  if (rotation) {
    mesh.rotation.copy(rotation);
  }

  const root = new Object3D();
  root.add(mesh);
  return root;
}

export function isMatchingWithInstance(instance: any, product: any): boolean {
  const instanceAttributes = instance.attributes || {};
  const productAttributes = product.attributes || {};
  return (
    instance &&
    product &&
    instance.productId == product.productId &&
    Object.entries(instanceAttributes).every(
      ([key, value]) => productAttributes[key] == value
    )
  );
}
